export const Video = ({ size = 32 }: { size?: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 33 34" fill="none">
      <path
        d="M1.73941 13.7555C1.97707 9.90606 4.93943 6.88128 8.76226 6.37057C11.1812 6.04742 13.969 5.77539 16.5 5.77539C19.073 5.77539 21.9115 6.05653 24.3579 6.38671C28.12 6.89445 31.0383 9.84341 31.2629 13.6329C31.3165 14.5371 31.35 15.502 31.35 16.5004C31.35 17.5237 31.3148 18.5118 31.2588 19.4355C31.0314 23.1903 28.1561 26.1222 24.4283 26.6258C22.0215 26.9509 19.1921 27.2254 16.5 27.2254C13.8517 27.2254 11.0705 26.9597 8.68955 26.6416C4.90096 26.1354 1.98418 23.1283 1.74368 19.3136C1.68632 18.4038 1.65002 17.4521 1.65002 16.5004C1.65002 15.5725 1.68452 14.6446 1.73941 13.7555Z"
        fill="url(#paint0_linear_2718_27080)"
      />
      <g filter="url(#filter0_di_2718_27080)">
        <path
          d="M22.1914 15.6107C22.916 15.9826 22.9159 17.0182 22.1914 17.3901L14.2441 21.4686C13.5786 21.8102 12.7875 21.3269 12.7875 20.579L12.7875 12.4218C12.7875 11.6738 13.5786 11.1906 14.2441 11.5321L22.1914 15.6107Z"
          fill="url(#paint1_linear_2718_27080)"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_2718_27080"
          x="4.78748"
          y="7.4209"
          width="25.9473"
          height="26.1592"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2718_27080" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2718_27080" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2718_27080" />
        </filter>
        <linearGradient
          id="paint0_linear_2718_27080"
          x1="16.5"
          y1="6.60039"
          x2="16.5"
          y2="26.4004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2A7FFF" />
          <stop offset="1" stopColor="#E232FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2718_27080"
          x1="18.975"
          y1="21.4504"
          x2="26.4"
          y2="15.6754"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0.41" />
        </linearGradient>
      </defs>
    </svg>
  )
}
